import styled, { css } from 'styled-components';

export const DropdownItem = styled.div`
  padding: 10px;
  width: 100%;
  outline: none;
  border: none;
  color: var(--grey700);
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 114.286% */
  border-bottom: 1px solid var(--grey300);
  cursor: pointer;
  &:hover {
    background-color: var(--grey200);
  }
  ${(props) =>
    !!props.isSelected &&
    css`
      font-weight: bolder;
    `}
  ${(props) =>
    !!props.hasPlaceholder &&
    css`
      cursor: default;
      background-color: var(--grey300);
    `}
`;
